// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { createBrowserHistory } from "history";
import firebase from "firebase/app";
import ReactPixel from "react-facebook-pixel";
import { hotjar } from "react-hotjar";
import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import configureStore from "./redux/store";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "./utils/i18next";
import Loading from "./components/Loading";
import { AppRouter } from "./router";

const { store, persistor } = configureStore();
export const history = createBrowserHistory();

const firebaseConfig = {
  apiKey: "AIzaSyAd60Xp92M9hkP5FYxzXgUcYGQcu3U3vgc",
  authDomain: "setpoint-62e00.firebaseapp.com",
  projectId: "setpoint-62e00",
  storageBucket: "setpoint-62e00.appspot.com",
  messagingSenderId: "80874519429",
  appId: "1:80874519429:web:f8cbca354c4c7c84ae62ec",
  measurementId: "G-1XPF5W3FN4",
};

// Development Purpose
// const firebaseConfig = {
//   apiKey: "AIzaSyDJlTwImxk2DFgGMfHq5TYa9bk7VyLS8UE",
//   authDomain: "setpoint-v2.firebaseapp.com",
//   projectId: "setpoint-v2",
//   storageBucket: "setpoint-v2.appspot.com",
//   messagingSenderId: "891671658648",
//   appId: "1:891671658648:web:1caa1fa91b7ceb2841d0ed",
//   measurementId: "G-JDJW6VQBLP"
// };

firebase.initializeApp(firebaseConfig);

// Facebook Pixel Config
ReactPixel.init("3813338835441150");
ReactPixel.pageView();

// Hotjar config
hotjar.initialize(2414702, 6);

// Private Route

function App(): ReactElement {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <AlertProvider template={AlertTemplate} timeout={50 * 1000} position={positions.BOTTOM_CENTER}>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AlertProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
